import {
  Box,
  Flex,
  Image,
  Input,
  InputGroup,
  InputProps,
  InputRightElement,
  Radio,
  Text,
} from "@chakra-ui/react";
import { SearchIcon } from "@root/assets";
import {
  deactivateSvg,
  reactivateSvg,
  submitSuccessSvg,
} from "@root/assets/admin";
import { NextSvg } from "@root/assets/admin/icons/next";
import { webCurrency } from "@root/webConstants";
import { useTranslation } from "react-i18next";
import {
  CustomOutLinedButton,
  CustomButton,
} from "../common/button/customButton";
import { CustomText } from "../common/components";
import { CustomDateRangePicker } from "../common/datepicker/customDatePicker";
import { CenterFlex, CenterFlexGap, ColumnFlex } from "../dashboard/chat/style";

export const Filters = ({ search, filterHandler, dates }: any) => {
  const { t } = useTranslation("common");
  return (
    <Flex padding={"16px"} gap={"16px"} flexDir={{ base: "column", sm: "row" }}>
      <InputGroup maxW={{ sm: "343px" }}>
        <Input
          value={search}
          _placeholder={{
            color: "theme.gray.300",
          }}
          placeholder={t("translate.faqs_search_query")}
          onChange={(e) => filterHandler("onInputChange", e)}
        />
        <InputRightElement>
          <SearchIcon color={"theme.gray.300"} />
        </InputRightElement>
      </InputGroup>

      <Box position={"relative"} height={"fit-content"} width={"230px"}>
        <CustomDateRangePicker
          dates={dates}
          placeholder={t("translate.select_added_date")}
          onDateSelect={(data: any) => filterHandler("onDateChange", data)}
          onClear={() => filterHandler("onDateClear")}
        />
      </Box>
    </Flex>
  );
};

export const DrawerHeader = ({ onClose = () => null, title = "" }: any) => (
  <Flex
    justifyContent={"space-between"}
    height={"66px"}
    bgColor={"theme.button.primary"}
    alignItems={"center"}
    padding={"0px 16px"}
  >
    <CustomText
      text={title}
      fontSize={"18px"}
      fontWeight={500}
      color={"#FFF"}
    />
    <NextSvg color={"#FFF"} onClick={onClose} />
  </Flex>
);

export const StatusViewer = ({ status = false }) => {
  const { t } = useTranslation("common");
  return (
    <CenterFlex gap={"8px"} justifyContent={"flex-start"}>
      <Box
        width={"6px"}
        height={"6px"}
        borderRadius={"50%"}
        bgColor={status ? "theme.success.100" : "theme.danger.900"}
      />
      <CustomText
        text={
          status ? t("userManagement.active") : t("userManagement.deActivated")
        }
      />
    </CenterFlex>
  );
};
interface IInputPairForAddUser extends InputProps {
  label: string;
}

export const InputPairForAddUser = ({
  placeholder,
  label,
  ...props
}: IInputPairForAddUser) => {
  return (
    <ColumnFlex gap={"8px"} width={"100%"}>
      <CustomText text={label} textAlign={"start"} />
      <Input maxHeight={"52px"} placeholder={placeholder} {...props} />
    </ColumnFlex>
  );
};

export const AddUserCardItem = ({
  state,
  plan = "",
  requestCount = "",
  prize = "",
  isCustom = false,
  checked = false,
  onChange,
  onChangeHandler,
}: any) => {
  const { t } = useTranslation("common");
  return (
    <Flex
      borderRadius={"16px"}
      padding={"16px"}
      gap={"16px"}
      border={"1px solid"}
      borderColor={"theme.gray.200"}
    >
      <Radio
        alignSelf={"flex-start"}
        mt={"4px"}
        isChecked={checked}
        onChange={onChange}
      />
      <ColumnFlex gap={"16px"}>
        <CustomText text={plan} fontWeight={500} fontSize={"16px"} />
        <CustomText
          type="grayText"
          text={`${t(
            "userManagement.requestCount"
          )}: ${requestCount} \u00A0 | \u00A0 Price: ${webCurrency}${prize}/month`}
        />
        {isCustom && (
          <>
            <InputPairForAddUser
              label={t("userManagement.numberOfRequest")}
              placeholder="0"
              type="number"
              value={state.total_request}
              onChange={onChangeHandler}
              name="total_request"
            />
            <InputPairForAddUser
              label={t("userManagement.price")}
              value={state.price}
              placeholder={t("userManagement.planPrice")}
              type="number"
              onChange={onChangeHandler}
              name="price"
            />
          </>
        )}
      </ColumnFlex>
    </Flex>
  );
};

export const SubmitSucessPopup = ({ createdUser }: any) => {
  const { t } = useTranslation("common");
  return (
    <ColumnFlex p={"16px"} gap={"16px"} alignItems={"center"}>
      <Image
        width={"120px"}
        height={"120x"}
        src={submitSuccessSvg}
        alt="success-image"
        mb={"4px"}
      />
      <CustomText
        text={t("userManagement.successful!")}
        fontSize={"24px"}
        fontWeight={500}
      />
      <Text fontSize={"16px"} fontWeight={400} color={"theme.gray.500"}>
        {t("userManagement.aNewUser")} “
        <span style={{ color: "#1782FF" }}>{createdUser?.username || ""}</span>”{" "}
        {t("userManagement.hasBeenCreatedSuccessfully.")}
      </Text>
    </ColumnFlex>
  );
};
export const DeactivatePopup = ({ onYes, onNo, loading, is_active }: any) => {
  const { t } = useTranslation("common");
  return (
    <ColumnFlex p={"16px"} gap={"16px"} alignItems={"center"}>
      <Image
        width={"120px"}
        height={"120x"}
        src={is_active ? deactivateSvg : reactivateSvg}
        alt="success-image"
        mb={"4px"}
      />
      <CustomText
        text={`${t("userManagement.areYouSureTo")} ${
          is_active
            ? t("userManagement.deActivate")
            : t("userManagement.reActivate")
        } ${t("userManagement.thisUser?")}`}
        fontSize={"24px"}
        fontWeight={500}
      />
      <CenterFlexGap>
        <CustomOutLinedButton
          text={
            is_active
              ? t("userManagement.yesDeactivate")
              : t("userManagement.yesReactivate")
          }
          maxH="40px"
          borderRadius="8px"
          padding="0px 30px"
          fontSize="14px"
          isLoading={loading}
          onClick={onYes}
        />
        <CustomButton
          maxH="44px"
          borderRadius="8px"
          padding="0px 30px"
          text={t("userManagement.notNow")}
          fontSize="14px"
          onClick={onNo}
          background="linear-gradient(180deg, #72A7DA 0%, #3075B6 100%)"
          _hover={{
            background: "linear-gradient(180deg, #72A7DA 0%, #3075B6 100%)",
          }}
        />
      </CenterFlexGap>
    </ColumnFlex>
  );
};
export const AdminConfirmationPopup = ({
  onYes,
  onNo,
  loading,
  isAdmin,
}: any) => {
  const { t } = useTranslation("common");
  return (
    <ColumnFlex p={"16px"} gap={"16px"} alignItems={"center"}>
      <Image
        width={"120px"}
        height={"120x"}
        src={!isAdmin ? deactivateSvg : reactivateSvg}
        alt="success-image"
        mb={"4px"}
      />
      <CustomText
        text={
          isAdmin
            ? t("userManagement.makeAdmin")
            : t("userManagement.removeAdmin")
        }
        fontSize={"24px"}
        fontWeight={500}
      />
      <CenterFlexGap>
        <CustomOutLinedButton
          text={
            isAdmin
              ? t("userManagement.yesMakeAdmin")
              : t("userManagement.yesRemoveAdmin")
          }
          maxH="40px"
          borderRadius="8px"
          padding="0px 30px"
          fontSize="14px"
          isLoading={loading}
          onClick={onYes}
        />
        <CustomButton
          fontFamily="Noto Sans KR, sans-serif"
          fontWeight={500}
          background="linear-gradient(180deg, #72A7DA 0%, #3075B6 100%)"
          _hover={{
            background: "linear-gradient(180deg, #72A7DA 0%, #3075B6 100%)",
          }}
          maxH="44px"
          borderRadius="8px"
          padding="0px 30px"
          text={t("userManagement.notNow")}
          fontSize="14px"
          onClick={onNo}
        />
      </CenterFlexGap>
    </ColumnFlex>
  );
};
